module.exports = __webpack_public_path__ + "img/dress.3d573d5a.svg";